import { ITrimEditorManagerBase } from '../trim-editor.manager';
import { TrimUiManager } from '../ui/trim.ui.manager';
import { TrimPanZoomManager } from '../pan-zoom/trim.pan-zoom.manager';
import { TrimRuler } from './trim.ruler';
import { TrimImageEditManager } from '../image-edit/trim.image-edit.manager';

export class TrimRulerManager implements ITrimEditorManagerBase {

  // - container -
  private container: HTMLDivElement;
  // - manager -
  private uiManager!: TrimUiManager;
  private panZoomManager!: TrimPanZoomManager;
  // - event handler -
  private onMouseMove: (e: MouseEvent) => void = () => {
  };
  // - ins -
  private ruler!: TrimRuler;

  constructor(container : HTMLDivElement) {
    this.container = container
  }

  di(
    imageEditManager: TrimImageEditManager,
    uiManager: TrimUiManager,
    panZoomManager: TrimPanZoomManager,
  ): void {
    // this.container = imageEditManager.getCanvasEle().parentElement as HTMLDivElement;
    this.uiManager = uiManager;
    this.panZoomManager = panZoomManager;
  }

  initialize(): void {
    this.ruler = new TrimRuler(this.container);
  }

  boot(): void {
    this.ruler.create();
    this.activate();
  }

  activate(): void {
    this.uiManager.on('t->r:zoom:change', (e) => {
      this.ruler.pan(e.x, e.y);
      this.ruler.zoom(e.scale);
    });
    this.onMouseMove = (e) => {
      const x = e.clientX;
      const y = e.clientY;
      this.ruler.moveGuide(x, y);
    };
    this.container.addEventListener('mousemove', this.onMouseMove);
  }

  destroy(): void {
    // ホットリロード対策
    if (!this.uiManager) return;
    this.uiManager.off('t->r:zoom:change');
    this.container.removeEventListener('mousemove', this.onMouseMove);
    this.ruler.destroy();
  }

}
